module.exports = __webpack_public_path__ + "img/pacmanmodel (14).f0871a83.jpg";